import { Button } from "@bitwarden/web-vault/app/components/buttons/gloss-button/button";

// No constructor: Button's is inherited as-is. Keeping a forwarding copy here meant every new
// IButton option had to be added in two places, and ariaLabel was missed in one (#4799).
export class ActionButton extends Button {}
